import React from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "../components/HeroSection";

const ContactUs = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us | EV91Technologies</title>
        <meta
          name="description"
          content="Contact EV91Technologies (VOICE) for queries, support, and business inquiries. We're here to help you with electric mobility solutions."
        />
        <meta
          name="keywords"
          content="Contact, EV91, VOICE, support, business, electric vehicles, logistics"
        />
        <meta property="og:title" content="Contact Us | EV91Technologies" />
        <meta
          property="og:description"
          content="Contact EV91Technologies (VOICE) for queries, support, and business inquiries. We're here to help you with electric mobility solutions."
        />
        <meta property="og:image" content="/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ev91riderz.com/contact-us" />
        <link rel="canonical" href="https://ev91riderz.com/contact-us" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Contact Us | EV91Technologies",
            "description": "Contact EV91Technologies (VOICE) for queries, support, and business inquiries. We're here to help you with electric mobility solutions.",
            "url": "https://ev91riderz.com/contact-us"
          }
        `}</script>
      </Helmet>

      <HeroSection
        title="Contact Us"
        subtitle="Having Queries? Don't hesitate to reach out to us!"
      />

      <section className="py-8 bg-green-100">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="flex flex-col md:flex-row items-start justify-center">
            <div className="md:w-1/2 bg-white p-6 rounded-lg shadow-md md:mr-8">
              <h2 className="text-2xl font-bold mb-4 text-green-800">
                Enquiry Form
              </h2>
              <form>
                <div className="mb-4">
                  <label className="block text-gray-700">Name</label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700">Email</label>
                  <input
                    type="email"
                    className="w-full px-3 py-2 border rounded"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="block text-gray-700">Message</label>
                  <textarea
                    className="w-full px-3 py-2 border rounded"
                    rows="4"
                    required
                  ></textarea>
                </div>

                <div className="mb-4">
                  <div
                    className="g-recaptcha"
                    data-sitekey="YOUR_RECAPTCHA_SITE_KEY"
                  ></div>
                </div>
                <button
                  type="submit"
                  className="bg-green-800 text-white py-2 px-4 rounded"
                >
                  Submit
                </button>
              </form>
            </div>

            <div className="md:w-1/2 mt-8 md:mt-0">
              <h2 className="text-2xl font-bold mb-4 text-green-800">
                Contact Information
              </h2>
              <p className="text-lg text-gray-700 mb-2">
                <strong>Email:</strong> info@ev91riderz.com
              </p>
              <p className="text-lg text-gray-700 mb-4">
                <strong>Phone:</strong> +91 90809 73764
              </p>

              {
                <iframe
                  title="Google Map"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.549086693182!2d77.62568367500414!3d12.936677115643162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15004fb8f8a3%3A0x179ff745fc109538!2sEV91Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1749290726846!5m2!1sen!2sin"
                  width="100%"
                  height="250"
                  frameBorder="0"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  aria-hidden="false"
                  tabIndex="0"
                ></iframe>
              }
            </div>
          </div>
        </div>
      </section>

      <section className="py-8 bg-white">
        <div className="container mx-auto">
          <h2 className="text-2xl font-bold mb-4 text-green-800">
            Our Locations
          </h2>
          <div className="flex flex-col md:flex-row">
            <div className="md:w-1/3 p-4">
              <h3 className="text-xl font-semibold text-green-800">
                <a
                  href="https://maps.app.goo.gl/dzw6L9BGraNEzXm27"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-green-800"
                >
                  Bengaluru
                </a>
              </h3>
              <p className="text-gray-700">
                Address: Site No. 23, A.V.S. Compound, 80 Feet Rd, 4th Block,
                Koramangala, Bengaluru, Karnataka-560095
              </p>
            </div>
            <div className="md:w-1/3 p-4 border-l border-gray-300">
              <h3 className="text-xl font-semibold text-green-800">
                <a
                  href="https://maps.app.goo.gl/X3EzZKDryTBAh1wh8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-green-800"
                >
                  Chennai
                </a>
              </h3>
              <p className="text-gray-700">
                Address: No. 8/46, S.Kolathur Main road, Kavimani Nagar,
                Kovilambakkam, Chennai, Tamilnadu-600129
              </p>
            </div>
            <div className="md:w-1/3 p-4 border-l border-gray-300">
              <h3 className="text-xl font-semibold text-green-800">
                <a
                  href="https://maps.app.goo.gl/sKMmG9gZQzKxB6D7A"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline text-green-800"
                >
                  Hyderabad
                </a>
              </h3>
              <p className="text-gray-700">
                Address: No. 6-3-1177/A/40 B.S Maqta, Kundabagh, Begumpet,
                Hyderabad, Telangana-500016
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
